import { Stack, Tooltip } from '@mui/material';
import { IconButton } from '@sweep-io/sweep-design';
import { Copy, Check } from '@sweep-io/sweep-design/dist/icons';
import { useState } from 'react';

export const SimpleTextCopyButton = ({ txt, itemName }: { txt: string; itemName?: string }) => {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <Stack className="copy-to-clipboard-button">
      <Tooltip
        key={isCopied ? 'copied' : 'copy'}
        title={isCopied ? `${itemName} Copied` : `Copy ${itemName}`}
        placement="top"
      >
        <span>
          <IconButton
            size="tiny"
            variant="flat"
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(txt);
              setIsCopied(true);
              setTimeout(() => {
                setIsCopied(false);
              }, 1000);
            }}
          >
            {isCopied ? <Check /> : <Copy />}
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};
